//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomSidebarMenuItem from './CustomSidebarMenuItem.vue'
import { sysEnts_showTree } from "@/apis/system";

export default ({
    components: {
        CustomSidebarMenuItem
    },
    props: {
        // Sidebar collapsed status.
        sidebarCollapsed: {
            type: Boolean,
            default: false,
        },

        // Main sidebar color.
        sidebarColor: {
            type: String,
            default: "primary",
        },

        // Main sidebar theme : light, white, dark.
        sidebarTheme: {
            type: String,
            default: "light",
        },

    },
    data() {
        return {
            rootSubmenuKeys: ['sub1', 'sub2', 'sub4'],
            // sidebarCollapsedModel: this.sidebarCollapsed,
            menuItems: null,
            openKeys: ['sub1'],
            selectedKeys: []
        }
    },
    onLoad() {

    },
    mounted() {
        this.pageLoad();
        //this.reSekected();
    },
    methods: {
        getRouteUrl(id, name) {
            const routes = [...this.$router.options.routes];
            const res = routes.filter(route => route.id == id);
            if (res.length > 0) {
                return res[0];
            }
        },
        async pageLoad() {
            let menus = [];
            let items = this.$store.state.user.allMenuRouteTree;
            items.forEach(item => {
                if (['PB', 'MO'].includes(item.entType)) {
                    return;
                }
                let children = [];
                if (item.children) {
                    for (let i = 0; i < item.children.length; i++) {
                        const element = item.children[i];
                        //console.log(element.entName, element.entId, this.getRouteUrl(element.entId))
                        let rowChildRounte = this.getRouteUrl(element.entId, element.entName) || {};
                        children.push(this.getItem(element.entName, element.entName, rowChildRounte.path || '/404', null));
                    }
                }

                let rowItem;
                let rowRounte = this.getRouteUrl(item.entId, item.entName) || {};
                if (children.length > 0) {
                    rowItem = this.getItem(item.entName, item.entName, rowRounte.path || '/404', "line-chart", children);
                } else {
                    rowItem = this.getItem(item.entName, item.entName, rowRounte.path || '/404', "line-chart");
                }
                menus.push(rowItem);
            })


            this.menuItems = menus;



            /* this.menuItems = [];
            this.menuItems.push(this.getItem('總覽', '總覽', '/home', 'line-chart'));

            this.menuItems.push(this.getItem('出席點名', '出席點名', null, 'shopping-cart', [
                this.getItem('出席與票券核銷', '出席與票券核銷', '/order/uncheck', null),
                this.getItem('當日報到狀態總覽', '當日報到狀態總覽', '/order/today', null),
            ]));

            this.menuItems.push(this.getItem('行事曆', '行事曆', '/matches-calendar', 'shopping-cart', null));

            this.menuItems.push(this.getItem('產品管理', '產品管理', null, 'line-chart', [
                // this.getItem('產品標籤', '產品標籤', '/', null,),
                // this.getItem('產品分類', '產品分類', '/', null,),
                // this.getItem('產品群組', '產品群組', '/', null,),
                this.getItem('產品總覽', '產品總覽', '/product', null,)
            ]));

            this.menuItems.push(this.getItem('票卷管理', '票卷管理', null, 'shopping-cart', [
                this.getItem('票卷管理', '票卷管理', '/order', null),
                this.getItem('票卷分類', '票卷分類', '/order-group', null),
                this.getItem('銷售記錄', '銷售記錄', '/sakes', null),
                this.getItem('點數清分', '點數清分', '/member/account-record', null)
            ]));

            this.menuItems.push(this.getItem('館務管理', '館務管理', null, 'home', [
                this.getItem('場館管理', '場館管理', '/gymnasium', null),
                this.getItem('場地管理', '場地管理', '/stadium', null),
                this.getItem('場次時段記錄', '場次時段記錄', '/matches-timeslot', null),
                // this.getItem('場次時段管理', '場次時段管理', '/matches-block', null),
                
            ]));



            // this.menuItems.push(this.getItem('客戶管理', '客戶管理', null, 'line-chart', [
            //     this.getItem('客戶管理', '客戶管理', '/clients', null,),
            //     this.getItem('點數管理', '點數管理', '/points', null),
            //     //this.getItem('點數方案管理', '點數方案管理', null, null),
            // ]));

            this.menuItems.push(this.getItem('管理工具', '管理工具', null, 'setting', [
                this.getItem('LOG記錄', 'LOG記錄', '/logs', null),
                this.getItem('賬號管理', '賬號管理', '/security/account', null),
                this.getItem('角色管理', '角色管理', '/security/role', null),
                this.getItem('權限管理', '權限管理', '/permission', null),
                this.getItem('黑名單管理', '黑名單管理', '/member/black', null),
                this.getItem('前臺管理', '前臺管理', '/client-side', null),
                //this.getItem('系統場館管理', '系統場館管理', '/system/gymnasium', null),
                this.getItem('運動類型', '運動類型', '/system/ball', null),
                this.getItem('品牌活動', '品牌活動', '/activity', null),
                this.getItem('輪播圖', '輪播圖', '/ad', null),
                this.getItem('品管管理', '品管管理', '/mch', null),
                this.getItem('客戶管理', '客戶管理', '/member', null),

                // this.getItem('分類設定', '分類設定', null, null, [
                //     //this.getItem('區域類型', '區域類型', '/system/region', null),                    
                // ]),
                //this.getItem('點數管理', '點數管理', '/page1', null),
                //this.getItem('系統文字設定', '系統文字設定', '/page1', null),
                //this.getItem('報表功能', '報表功能', '/page1', null),
            ]))
            console.log('menu', this.menuItems) */

        },
        reSekected() {
            const url = this.$route.path;
            this.openKeys = [];
            this.selectedKeys = [];

            //const menus = this.menuItems;
            this.menuItems.forEach(item => {
                if (item.children) {
                    item.children.forEach(children => {
                        if (children.href == url) {
                            this.openKeys.push(item.key);
                            this.selectedKeys.push(item.key)
                            this.selectedKeys.push(children.key)
                        }
                    })
                } else {
                    if (item.href == url) {
                        this.selectedKeys.push(item.key);
                    }
                }
            });
            console.log('url', url)
            console.log('openKeys', this.openKeys)
            console.log('selectedKeys', this.selectedKeys)
        },
        getItem(label, key, href, icon, children) {
            return {
                key,
                href,
                icon,
                children,
                label
            };
        },
        handleClick() {

        },
        onOpenChange(openKeys) {
            const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
            if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                this.openKeys = openKeys;
            } else {
                this.openKeys = latestOpenKey ? [latestOpenKey] : [];
            }
        },

    }
})

